import { useReducer, createContext, useEffect, useState } from "react";
// import { auth } from "../firebase";

// reducer
const goglobalReducer = (state, action) => {
  // console.log("state::", state)
  switch (action.type) {
    case "LOGGED_IN_USER":
      return { ...state, user: action.payload };
    default:
      return state;
  }
};

// state
const initialState = {
  user: null,
};

// create context
const AuthContext = createContext();

// context provider
const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(goglobalReducer, initialState);

  //=================== Get Role From Local Storage ==============
  const [role, setRole] = useState("");
  useEffect(() => {
    const checkRole = async () => {
      let userData = await JSON.parse(window.localStorage.getItem("userLogin"));
      if (userData?.role) {
        setRole(userData?.role);
      } else {
        setRole("");
      }
    };
    checkRole();
  }, [role, window.localStorage.getItem("userLogin")]);

  // ================== Check role and Permissions ======================== 
  const noneUserAccesse = (roles) => {
    const getRole = roles.filter((rol) => rol === role);
    if (getRole.length > 0) {
      //no access
      return true;
    } else {
      //can access
      return false;
    }
  };

  // ==================== change language =============================
  const [language, setLanguage] = useState("kh");
  const changeLanguage = (lang) => {
    // console.log("Auth Language => ",lang)
    setLanguage(lang);
  };

  // ========================= Alert Message ===========================
  const [open, setOpen] = useState(false);
  const [alertStatus, setAlertStatus] = useState("");
  const [messageAlert, setMessageAlert] = useState({ messageKh: '', messageEn: '' });

  const setAlert = (open, alert, message) => {
    setOpen(open);
    setAlertStatus(alert);
    setMessageAlert(message);
  };
  const alert = () => {
    return { open: open, status: alertStatus, message: messageAlert };
  };

  //============================ return ==========================
  const value = {
    state,
    dispatch,
    noneUserAccesse,
    alert,
    setAlert,
    changeLanguage,
    language,
    role,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// export
export { AuthContext, AuthProvider };
